import { Space } from "antd";
import AddVenueToSeasonButton from "./AddVenueToSeasonButton";

const getVenueCommonColumns = ({ formatMessage }) => [
  {
    title: formatMessage({
      id: "name.local",
      defaultMessage: "Local Name",
    }),
    dataIndex: "nameLocal",
  },
  {
    title: formatMessage({
      id: "country",
      defaultMessage: "Country",
    }),
    dataIndex: "countryCode",
  },
  {
    title: formatMessage({
      id: "timezone",
      defaultMessage: "Time Zone",
    }),
    dataIndex: "timezone",
  },
  {
    title: formatMessage({
      id: "venue.id",
      defaultMessage: "Venue ID",
    }),
    dataIndex: "venueId",
  },
];

export const getAddVenueToSeasonColumns = ({ formatMessage, sport, seasonId, organizationId, reloadData, pageRef }) => [
  ...getVenueCommonColumns({ formatMessage }),
  {
    title: null,
    align: "right",
    render: (value, row) => (
      <Space size="small">
        <AddVenueToSeasonButton
          sport={sport}
          seasonId={seasonId}
          organizationId={organizationId}
          venueId={row.venueId}
          reloadData={reloadData}
          pageRef={pageRef}
        />
      </Space>
    ),
  },
];
